import { ErrorOutlineOutlined } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const AiScreeningLimitAlert: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <Stack mb={2} mr={4} bgcolor="error.light" p={2} direction="row" justifyContent="space-between" spacing={2}>
      <ErrorOutlineOutlined />
      <Stack direction="row" justifyContent="space-between" flexGrow={1}>
        <Stack>
          <Typography fontWeight={500} gutterBottom>
            {formatMessage({ id: 'aiScreening.infoPage.noRemainingScreenings' })}
          </Typography>
          <Typography gutterBottom variant="caption" color="textSecondary">
            {formatMessage({ id: 'aiScreening.infoPage.noRemainingScreeningsDescription' })}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default AiScreeningLimitAlert
